// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZjAiT","img":"styles_img__C7+l5","spacer":"styles_spacer__fwrnX"};